import styled from 'styled-components';
import { getFont, getLineHeight } from '@finect/tabular-utils/getFont';
import { Pulse } from './Pulse';
export var SkeletonTableCell = styled(Pulse).withConfig({
  displayName: "SkeletonTableCell",
  componentId: "sc-vafc9u-0"
})(["height:", "rem;border-radius:5px;", ""], getLineHeight(0), getFont(0));